import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon/Icon.js';
import styles from './Avatar.module.scss.js';

var sizes = ['small', 'medium', 'large'];
function Avatar(_ref) {
  var initials = _ref.initials,
    size = _ref.size,
    disabled = _ref.disabled,
    icon = _ref.icon,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.avatar, styles[size], disabled && styles.disabled, className)
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: "medium"
  }), initials);
}
Avatar.propTypes = {
  initials: PropTypes.string,
  size: PropTypes.oneOf(sizes),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.string
};
Avatar.defaultProps = {
  size: 'large',
  disabled: false,
  className: '',
  icon: '',
  initials: ''
};

export { Avatar as default };
